import { PropsWithChildren, createContext, useContext } from "react";

const defaultApiUrl = "https://cuanto-staging.herokuapp.com";
const Context = createContext(defaultApiUrl);

export default function useApiUrl() {
  return useContext(Context);
}

type ProviderProps = PropsWithChildren<{ apiUrl: string }>;
export function ApiUrlProvider({ apiUrl, children }: ProviderProps) {
  return <Context.Provider value={apiUrl}>{children}</Context.Provider>;
}
